export default __webpack_public_path__ + "static/media/mode-62.112dac84.svg";